'use client';

import { FC, memo } from 'react';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useTranslations } from 'next-intl';
import { WlasParamDef } from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/constants';
import { WlasValues } from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/utils';
import {
  CardBody,
  CardHeader,
  CollapseToggle,
  SectionLabel,
} from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/styled';
import { SectionHeaderContent } from './styled';
import { WlasParamRow } from './components/WlasParamRow';
import { WlasChevronIcon } from './WlasChevronIcon';

interface WlasSectionProps {
  labelKey: string;
  params: WlasParamDef[];
  values: WlasValues;
  onChange: (id: string, value: string | boolean) => void;
  isFirst?: boolean;
}

export const WlasSection: FC<WlasSectionProps> = memo(
  ({ labelKey, params, values, onChange, isFirst }) => {
    const t = useTranslations('wlasWidget');
    const storageKey = `wlas-section-${labelKey.replace(/\./g, '-')}`;
    const [open, setOpen] = useLocalStorage(storageKey, true);

    return (
      <div>
        <CardHeader $first={isFirst} onClick={() => setOpen((v) => !v)}>
          <SectionHeaderContent>
            <SectionLabel>{t(labelKey)}</SectionLabel>
          </SectionHeaderContent>
          <CollapseToggle
            type="button"
            aria-expanded={open}
            onClick={(e) => {
              e.stopPropagation();
              setOpen((v) => !v);
            }}
          >
            <WlasChevronIcon open={open} />
          </CollapseToggle>
        </CardHeader>
        {open && (
          <CardBody>
            {params.map((param) => (
              <WlasParamRow key={param.id} param={param} values={values} onChange={onChange} />
            ))}
          </CardBody>
        )}
      </div>
    );
  },
) as FC<WlasSectionProps>;
WlasSection.displayName = 'WlasSection';
